import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

export const renderRichText = (el, renderOptions = {}) => {
  if (!el) return null;

  const textObject = JSON.parse(el.raw);

  const defaultOptions = {
    renderText: (text) =>
      text.split('\n').reduce((acc, segment, i) => {
        return i === 0
          ? [segment]
          : [...acc, <br key={i} />, segment];
      }, []),
    ...renderOptions,
  };

  return documentToReactComponents(textObject, defaultOptions);
};
